"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Expo = void 0;

var tslib_1 = require("tslib");

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var ui_vector_graphic_1 = require("@hopin-team/ui-vector-graphic");

var react_1 = tslib_1.__importDefault(require("react"));

var Expo = function Expo(_a) {
  var title = _a.title,
      props = tslib_1.__rest(_a, ["title"]);

  return react_1.default.createElement(ui_vector_graphic_1.VectorGraphic, tslib_1.__assign({}, props, {
    title: title !== null && title !== void 0 ? title : 'Expo',
    viewBox: "0 0 320 250",
    __UIScope: "Expo"
  }), react_1.default.createElement("g", {
    clipPath: "url(#Expo__clip0)"
  }, react_1.default.createElement("rect", {
    width: "320",
    height: "202",
    y: "40",
    fill: ui_symbols_1.COLOR.GREY[100],
    opacity: "0.75",
    rx: "12"
  }), react_1.default.createElement("g", {
    filter: "url(#Expo__filter0_d)"
  }, react_1.default.createElement("rect", {
    width: "183",
    height: "170",
    x: "16",
    y: "8",
    fill: ui_symbols_1.COLOR.GREY.WHITE,
    rx: "8"
  }), react_1.default.createElement("rect", {
    width: "72",
    height: "14",
    x: "36",
    y: "132",
    fill: ui_symbols_1.COLOR.GREY[200],
    rx: "7"
  }), react_1.default.createElement("rect", {
    width: "125",
    height: "8",
    x: "36",
    y: "154",
    fill: ui_symbols_1.COLOR.GREY[100],
    opacity: "0.48",
    rx: "4"
  }), react_1.default.createElement("g", {
    clipPath: "url(#Expo__clip1)"
  }, react_1.default.createElement("rect", {
    width: "167",
    height: "100",
    x: "24",
    y: "16",
    fill: ui_symbols_1.COLOR.GREEN[100],
    rx: "4"
  }), react_1.default.createElement("rect", {
    width: "47.587",
    height: "43.261",
    x: "38",
    y: "-6",
    fill: ui_symbols_1.COLOR.GREEN[200],
    rx: "8"
  }), react_1.default.createElement("circle", {
    cx: "93.555",
    cy: "38.399",
    r: "23.224",
    fill: ui_symbols_1.COLOR.GREEN[400],
    opacity: "0.05"
  }), react_1.default.createElement("path", {
    fill: ui_symbols_1.COLOR.GREEN[400],
    d: "M85.587 16.578v12.645a8 8 0 01-8 8H70.36c.474-9.514 6.674-17.521 15.226-20.645z",
    opacity: "0.05"
  }), react_1.default.createElement("path", {
    fill: ui_symbols_1.COLOR.GREEN[200],
    d: "M71.423 45.454a48.633 48.633 0 0122.02-5.234c7.999 0 15.55 1.924 22.214 5.334-3.017 9.325-11.771 16.069-22.101 16.069-10.367 0-19.147-6.792-22.133-16.169z",
    opacity: "0.2"
  }), react_1.default.createElement("circle", {
    cx: "93.839",
    cy: "88.839",
    r: "48.839",
    fill: ui_symbols_1.COLOR.GREY.WHITE,
    opacity: "0.5"
  }))), react_1.default.createElement("g", {
    filter: "url(#Expo__filter1_d)"
  }, react_1.default.createElement("rect", {
    width: "70",
    height: "30",
    x: "29",
    y: "196",
    fill: ui_symbols_1.COLOR.GREY.WHITE,
    rx: "15"
  })), react_1.default.createElement("circle", {
    cx: "44",
    cy: "211",
    r: "12",
    fill: ui_symbols_1.COLOR.BLUE[200]
  }), react_1.default.createElement("path", {
    stroke: ui_symbols_1.COLOR.THEME.PRIMARY,
    strokeLinecap: "round",
    strokeWidth: "2",
    d: "M44 207v8m-4-4h8"
  }), react_1.default.createElement("g", {
    filter: "url(#Expo__filter2_d)"
  }, react_1.default.createElement("rect", {
    width: "183",
    height: "170",
    x: "121",
    y: "56",
    fill: ui_symbols_1.COLOR.GREY.WHITE,
    rx: "8"
  }), react_1.default.createElement("rect", {
    width: "72",
    height: "14",
    x: "141",
    y: "180",
    fill: ui_symbols_1.COLOR.GREY[200],
    rx: "7"
  }), react_1.default.createElement("rect", {
    width: "21",
    height: "14",
    x: "221",
    y: "180",
    fill: ui_symbols_1.COLOR.GREY[200],
    rx: "7"
  }), react_1.default.createElement("rect", {
    width: "125",
    height: "8",
    x: "141",
    y: "202",
    fill: ui_symbols_1.COLOR.GREY[100],
    opacity: "0.48",
    rx: "4"
  }), react_1.default.createElement("g", {
    clipPath: "url(#Expo__clip2)"
  }, react_1.default.createElement("rect", {
    width: "167",
    height: "100",
    x: "129",
    y: "64",
    fill: ui_symbols_1.COLOR.BLUE[100],
    rx: "4"
  }), react_1.default.createElement("path", {
    fill: ui_symbols_1.COLOR.GREEN[200],
    d: "M176.423 93.454a48.632 48.632 0 0122.019-5.234c8 0 15.551 1.924 22.215 5.334-3.017 9.325-11.771 16.069-22.101 16.069-10.367 0-19.147-6.792-22.133-16.17z",
    opacity: "0.2"
  }), react_1.default.createElement("path", {
    fill: ui_symbols_1.COLOR.BLUE[300],
    d: "M188.087 116.187c0 6.158 6.667 10.007 12 6.928l16.69-9.636-14.773-25.587c-3.079-5.334-10.777-5.334-13.856 0l-.061.105v28.19z",
    opacity: "0.3"
  }), react_1.default.createElement("path", {
    fill: ui_symbols_1.COLOR.BLUE[200],
    d: "M253.498 128.128c-5.311-3.118-5.255-10.816.101-13.856l44.41-25.21c5.356-3.04 11.994.857 11.949 7.015l-.372 51.066c-.045 6.158-6.739 9.958-12.05 6.84l-44.038-25.855z",
    opacity: "0.6"
  })))), react_1.default.createElement("defs", null, react_1.default.createElement("filter", {
    id: "Expo__filter0_d",
    width: "207",
    height: "194",
    x: "8",
    y: "-4",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, react_1.default.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), react_1.default.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), react_1.default.createElement("feOffset", {
    dx: "4"
  }), react_1.default.createElement("feGaussianBlur", {
    stdDeviation: "6"
  }), react_1.default.createElement("feColorMatrix", {
    values: "0 0 0 0 0.886719 0 0 0 0 0.905528 0 0 0 0 0.945833 0 0 0 0.32 0"
  }), react_1.default.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), react_1.default.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), react_1.default.createElement("filter", {
    id: "Expo__filter1_d",
    width: "94",
    height: "54",
    x: "21",
    y: "184",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, react_1.default.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), react_1.default.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), react_1.default.createElement("feOffset", {
    dx: "4"
  }), react_1.default.createElement("feGaussianBlur", {
    stdDeviation: "6"
  }), react_1.default.createElement("feColorMatrix", {
    values: "0 0 0 0 0.886719 0 0 0 0 0.905528 0 0 0 0 0.945833 0 0 0 0.32 0"
  }), react_1.default.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), react_1.default.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), react_1.default.createElement("filter", {
    id: "Expo__filter2_d",
    width: "207",
    height: "194",
    x: "113",
    y: "44",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, react_1.default.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), react_1.default.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), react_1.default.createElement("feOffset", {
    dx: "4"
  }), react_1.default.createElement("feGaussianBlur", {
    stdDeviation: "6"
  }), react_1.default.createElement("feColorMatrix", {
    values: "0 0 0 0 0.886719 0 0 0 0 0.905528 0 0 0 0 0.945833 0 0 0 0.32 0"
  }), react_1.default.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), react_1.default.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), react_1.default.createElement("clipPath", {
    id: "Expo__clip0"
  }, react_1.default.createElement("path", {
    fill: ui_symbols_1.COLOR.GREY.WHITE,
    d: "M0 0H320V250H0z"
  })), react_1.default.createElement("clipPath", {
    id: "Expo__clip1"
  }, react_1.default.createElement("rect", {
    width: "167",
    height: "100",
    x: "24",
    y: "16",
    fill: ui_symbols_1.COLOR.GREY.WHITE,
    rx: "4"
  })), react_1.default.createElement("clipPath", {
    id: "Expo__clip2"
  }, react_1.default.createElement("rect", {
    width: "167",
    height: "100",
    x: "129",
    y: "64",
    fill: ui_symbols_1.COLOR.GREY.WHITE,
    rx: "4"
  }))));
};

exports.Expo = Expo;